module.exports = __webpack_public_path__ + "img/code3.aa924022.png";